<div #appContent style="display: none;">
  <iframe #iframe src="" class="iframeStyling">

  </iframe>
</div>

